module.exports = __webpack_public_path__ + "ebcc27fb31c67a1a4a6e47e721a18198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-1.jpg
// module id = 75
// module chunks = 0